import React from "react";
import TextFieldArtistSuggestions from "../../../components/textField/textFieldArtistSuggestions";
import Button from "../../../components/button";
import { useSafeNavigate } from "../../../components/unloadBlocker";
import { useNavigate } from "react-router-dom";

export default function DashboardAdminCreatePiecePage() {

    const navigate = useSafeNavigate(useNavigate());

    const [error, setError] = React.useState<string>("");
    const [artistId, setArtistId] = React.useState<number>(-1);
    const [artistSearch, setArtistSearch] = React.useState<string>("");

    return <div className="page">
        <p>Choose the artist you want to create a piece for.</p>
        <a>Artist ID: {artistId}</a>
        <TextFieldArtistSuggestions label="Artist Name" value={artistSearch} onChange={setArtistSearch} setArtist={(id, name) => {
            setArtistId(id);
            setArtistSearch(name);
        }}/>
        <a className="error">{error}</a>
        <Button disabled={artistId === -1} onClick={() => {
            if(artistId == -1) {
                setError("Please select an artist to continue.");
                return;
            }
            navigate(artistId + "");
        }}>Continue</Button>
    </div>

}